import { styled } from "@mui/system";
import { Grid } from "@mui/material";

export const DialogContentContainer = styled('div') ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const DialogInputContainer = styled('div') ({
    rowGap: 5,
    marginTop: '1em',
    display: 'flex',
    flexDirection: 'column'
});

export const InputSection = styled('div') ({
    border: '1px solid #d5d5d5ff',
    borderRadius: '20px',
    padding: '1em',
    marginBottom: '1em'
})

export const InputFieldContainer = styled('div') ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    width: '100%',
    marginTop: '0.5em',
    marginBottom: '1em',
    columnGap: '1em'
})

export const ValidatedInputFieldContainer  = styled('div') ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginBottom: '1em',
    columnGap: '1em'
})

export const ComparisonContainer = styled(Grid) ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: '1em',
    paddingTop: '2em'
})

export const ComparisonItem = styled(Grid) ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%'
})

